import React from 'react'
import { Modal, Spin } from 'antd'

const LoadingModal = ({ isOpen }) => (
    <Modal centered visible={isOpen} footer={null} closable={false} wrapClassName="loading-modal">
        <Spin size="large" />
    </Modal>
)

export default LoadingModal